import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const CloudFileContainer = styled.a<{ isSelected: boolean }>`
  display: block;
  position: relative;
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  text-decoration: none;
  color: ${theme.color.black};
  background-color: ${(props) =>
    props.isSelected
      ? theme.color.designSystem.purple30
      : theme.color.designSystem.grey20};
  border-radius: ${theme.borderRadius.medium};
  margin-top: ${theme.spacing.small};
  margin-bottom: ${theme.spacing.small};

  // Account for the border when adding padding
  padding: calc(${theme.spacing.small} - 1px);
  border: ${(props) =>
    props.isSelected
      ? `1px solid ${theme.color.designSystem.purple70}`
      : `1px solid ${theme.color.designSystem.grey20}`};
  ${(props) =>
    !props.isSelected &&
    `&:hover {
        background-color: #D6D6D6;
    }`}
`;

export const CloudFileDetails = styled.div`
  display: flex;
  align-items: center;
  min-height: 44px;
`;

export const CloudFileName = styled.span`
  padding-left: 7px;
  width: 100%;
`;

export const CloudFileEmbedContainer = styled.div`
  padding: ${theme.spacing.xxSmall};
  padding-top: ${theme.spacing.large};
  padding-left: ${theme.spacing.xLarge};
`;
